import { cn } from '@/lib/utils';

type SubTab = 'income' | 'expenses';

interface BusinessTransactionsSubNavProps {
  activeSubTab: SubTab;
  onSubTabChange: (tab: SubTab) => void;
}

const tabs: { key: SubTab; label: string }[] = [
  { key: 'income', label: 'Ingresos' },
  { key: 'expenses', label: 'Egresos' },
];

const BusinessTransactionsSubNav = ({ activeSubTab, onSubTabChange }: BusinessTransactionsSubNavProps) => {
  return (
    <div className="border-b border-border">
      <nav className="flex gap-6" aria-label="Business transactions tabs">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onSubTabChange(tab.key)}
            className={cn(
              'pb-3 text-sm font-medium transition-colors relative',
              activeSubTab === tab.key
                ? 'text-foreground'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {tab.label}
            {activeSubTab === tab.key && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary rounded-full" />
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default BusinessTransactionsSubNav;
